<template>
  <div class="relative dib v-mid overflow-hidden" >
    <div :style="`background: url('${ASSETS_CDN}/icons/icon-rating-grey.svg') left bottom repeat-x; height: 14px; width: 70px`"></div>
    <div class="absolute left-0 top-0 overflow-hidden" :style="`width: ${props.percent}%`">
      <span :style="`background: url('${ASSETS_CDN}/icons/icon-rating-yellow.svg') left bottom repeat-x; height: 14px; width: 70px`" class="db w-78 yellow fs-16"></span>
    </div>
  </div>
</template>

<script setup>

  import {assetCDN} from '~/helper/index.js';

  const props = defineProps({
    percent: { type: Number, default: 100}
  })

  const ASSETS_CDN = assetCDN()
</script>

<style scoped lang="scss">

</style>
